module.exports = __webpack_public_path__ + "img/invitationUseTickets.2d40ab71.svg";